import React from 'react';
import { classNames } from '../../utils/style';
export interface EmbedArcadeProps {
  src: string;
}

export const EmbedArcade: React.FC<EmbedArcadeProps> = ({ src }) => {
  if (!src.includes('demo.arcade.software')) {
    throw new Error(
      'EmbedArcade: Invalid Ausha URL. URL must contain "demo.arcade.software": ' +
        src,
    );
  }

  return (
    <div className={classNames('EmbedArcade', 'relative z-10')}>
      <div
        className={classNames(
          'rounded-[20px] border border-[#0000001A] shadow-iframe',
          'bg-[#f5fafb]',
        )}
      >
        <div className={classNames('overflow-hidden rounded-[20px]')}>
          <div
            className={classNames(
              'relative w-full',
              'h-0 pb-[calc(66.66666666666666%+41px)] md:pb-[calc(66.66666666666666%)]',
            )}
          >
            <iframe
              src={src}
              title={"Arcade"}
              loading="lazy"
              allowFullScreen
              allow="clipboard-write"
              className={classNames(
                'absolute -left-[2px] -top-[2px] h-[calc(100%+4px)] w-[calc(100%+4px)]',
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmbedArcade;
